// @ts-nocheck
import * as types from '../../mutation-types';
import actions from './actions';
import utils from '@/utils/analytics-utils';
import logger from '@/app/logger';

const state = {
  dataLayer: {},
  analyticsString: '',
  suspended: false,
  ocmBannerReady: false,
};

const mutations = {
  [types.analytics.init](state) {
    state.dataLayer = {
      eVar5: 'fi_fi',
      eVar10: document.domain,
      eVar11: window.location.pathname,
    };
  },
  [types.analytics.set](state, payload) {
    state.dataLayer = Object.assign(state.dataLayer, payload);
  },
  [types.analytics.saveString](state, payload) {
    if (typeof payload === 'string') {
      state.analyticsString = payload;
    } else {
      logger.warn('Analytics string is not a string', { payload });
    }
  },
  [types.analytics.suspend](state, suspended) {
    state.suspended = suspended;
  },
  [types.analytics.ocmBannerReady](state, isReady) {
    state.ocmBannerReady = isReady;
  },
};

const getters = {
  dataLayer: (state) => state.dataLayer,
  analyticsString: (state) => state.analyticsString,
  shouldFireSearchEvent: (state) => (filters, cities, districts, streets, regions) =>
    state.analyticsString !== utils.formAnalyticsInput(filters, cities, districts, streets, regions),
  analyticsCallsSuspended: (state) => state.suspended,
  ocmBannerReady: (state) => state.ocmBannerReady,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
